"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { commonApiFetch } from "@/services/api/common-api";
import { AuthContext } from "@/components/auth/Auth";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import WaveDropQuote from "./WaveDropQuote";
interface WaveDropQuoteWithDropIdProps {
  readonly dropId: string;
  readonly partId: number;
  readonly maybeDrop: ApiDrop | null;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
}
const WaveDropQuoteWithDropId: React.FC<WaveDropQuoteWithDropIdProps> = t0 => {
  const $ = _c(18);
  const {
    dropId,
    partId,
    maybeDrop,
    onQuoteClick,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const t1 = connectedProfile?.handle;
  let t2;
  if ($[0] !== dropId || $[1] !== t1) {
    t2 = [QueryKey.DROP, {
      drop_id: dropId,
      context_profile: t1
    }];
    $[0] = dropId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== connectedProfile || $[4] !== dropId) {
    t3 = async () => await commonApiFetch({
      endpoint: `drops/${dropId}`,
      params: connectedProfile?.handle ? {
        context_profile: connectedProfile.handle
      } : {}
    });
    $[3] = connectedProfile;
    $[4] = dropId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = maybeDrop ?? undefined;
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      placeholderData: keepPreviousData,
      initialData: t4
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    data: drop
  } = useQuery(t5);
  const t6 = drop ?? null;
  let t7;
  if ($[10] !== embedDepth || $[11] !== embedPath || $[12] !== maxEmbedDepth || $[13] !== onQuoteClick || $[14] !== partId || $[15] !== quotePath || $[16] !== t6) {
    t7 = <WaveDropQuote drop={t6} partId={partId} onQuoteClick={onQuoteClick} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} />;
    $[10] = embedDepth;
    $[11] = embedPath;
    $[12] = maxEmbedDepth;
    $[13] = onQuoteClick;
    $[14] = partId;
    $[15] = quotePath;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default WaveDropQuoteWithDropId;